import { ActionTypes } from "../actions/actionTypes";

const initialstate = {
  loading: false,
  error: null,
  otpSent: false,
  phone: "",
  otp_id: 0,
};
export const sendOtpReducer = (state = initialstate, action) => {
  switch (action.type) {
    case ActionTypes.GET_OTP_REQUEST: {
      return { ...state, loading: true, error: null };
    }
    case ActionTypes.GET_OTP_SUCCESS: {
	 
      return {
        ...state,
        otpSent: true,
        otp_id: action.payload.data,
        loading: false,
        phone: action.payload.phone,
        error: null,
      };
    }
    case ActionTypes.CHANGE_NUMBER:
      state = initialstate;
      return state;
    case ActionTypes.GET_OTP_ERROR: {
      return { ...state, loading: false, error: action.payload };
    }
    case ActionTypes.RESTART_DATA: {
      state = initialstate;
      return state;
    }
    case ActionTypes.STOP_LOADING:
      return { ...state, loading: false };
    default:
      return state;
  }
};
